import React, { useRef } from 'react'
import Button from '../../components/Button'
import styles from './ProfileSummaryButton.css'

export const ProfileSummaryButton = ({ name, handler, enabled }: any) => {
  const waiting = useRef<boolean>()
  const onClick = async () => {
    if (waiting.current) {
      return
    }
    try {
      waiting.current = true
      const result = handler()
      if (result && result.then) {
        await result
      }
    } catch (e) {
      console.error(e)
    } finally {
      waiting.current = false
    }
  }

  return (
    <Button
      className={styles.editButton}
      type="submit"
      label={name}
      onClick={onClick}
      disabled={!enabled}
    />
  )
}

export default ProfileSummaryButton
